/* eslint-disable
  import/no-extraneous-dependencies
*/
import './index.scss';

import React from 'react';
import createReactClass from 'create-react-class';
import Header from '../header';

const DarkHeader = createReactClass({
  render() {
    return (
      <Header className={`dark ${this.props.className || ''}`} {...this.props}>
        {this.props.children}
      </Header>
    );
  },
});

export default DarkHeader;
